module.exports = __webpack_public_path__ + "static/media/kuboou2.7a133866.png";